module.exports = __webpack_public_path__ + "static/img/beijing3.49e324c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/beijing3.jpg
// module id = ZQN1
// module chunks = 1